module.exports = __webpack_public_path__ + "static/media/CT_CC (Beyond Masungi).82b5d0ec.png";